import { useCallback, useState } from 'react';

const clamp = (value) => Math.min(1, Math.max(0, Number(value) || 0));

/**
 * A volume level (0–1) remembered in this browser (localStorage). Falls back
 * to `initial` when nothing is stored or storage is unavailable.
 */
const useStoredVolume = (key, initial = 1) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return stored === null || Number.isNaN(Number(stored)) ? initial : clamp(stored);
    } catch {
      return initial;
    }
  });
  const update = useCallback((next) => {
    const level = clamp(next);
    setValue(level);
    try {
      window.localStorage.setItem(key, String(level));
    } catch {
      // Tarayıcı depolaması kapalıysa yalnızca bu oturumda geçerli
    }
  }, [key]);
  return [value, update];
};

export default useStoredVolume;
